
export class GeneralNotes {
    date_created?: string;
    date_modified?: string;
    notes: string = "";
}
